import {
  useState,
  useEffect,
  type FC,
} from "react";
import { Badge } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";

type GameRoom = {
  roomId: string,
  numClients: number,
  maxClients: number,
  displayName: string,
}

type FabulaUltimaJoinGamePanelProps = {
  gameIsOngoing: boolean,
  rooms: ReadonlyArray<GameRoom>,
  handleJoinGame: (user: string, roomId: string, isGm: boolean) => void;
  handleLeaveGame: () => void;
  players: ReadonlyArray<string>;
};

const FabulaUltimaJoinGamePanel: FC<FabulaUltimaJoinGamePanelProps> = (props) => {
  const [userName, setUserName] = useState<string>("");
  const [isGm, setIsGm] = useState<boolean>(false);
  const [selectedRoomId, setSelectedRoomId] = useState<string>("");

  // 设置默认选中的房间
  useEffect(() => {
    if (props.rooms.length > 0 && selectedRoomId === "") {
      setSelectedRoomId(props.rooms[0].roomId);
    }
  }, [props.rooms, selectedRoomId]);

  let inner = null;
  let bgColor = "dark";

  if (props.gameIsOngoing) {
    inner = <>
      { props.players.join(", ") }&nbsp;&nbsp;
      {isGm && <Badge bg="warning" className="mx-2 fs-6">GM模式</Badge>}
      <Button variant="danger" onClick={props.handleLeaveGame}>离开游戏</Button>
    </>
    if (isGm) {
      bgColor = "info";
    }
  } else {
    inner = <>
      <div className="mb-3">
        <h5>选择房间</h5>
        <p className="text-muted small mb-2">
          点击房间名称选择要加入的房间。
        </p>
        <div className="list-group">
          {
            props.rooms.map(room => {
              const isSelected = selectedRoomId === room.roomId;
              const isFull = room.numClients >= room.maxClients;
              const isDisabled = isFull && !isGm; // GM可以加入满员房间
              
              return (
                <div
                  key={room.roomId}
                  className={`list-group-item list-group-item-action ${
                    isSelected ? 'active' : ''
                  } ${isDisabled ? 'disabled' : ''}`}
                  style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                  onClick={() => !isDisabled && setSelectedRoomId(room.roomId)}
                >
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-1">
                        {room.displayName}
                        {room.numClients > 0 && <span className="ms-1" title="房间内有玩家">👤</span>}
                      </h6>
                      <small>ID: <code>{room.roomId}</code></small>
                    </div>
                    <div className="text-end">
                      <Badge 
                        bg={isFull ? 'danger' : 'success'}
                        className="mb-1"
                      >
                        {room.numClients}/{room.maxClients}
                      </Badge>
                      {isFull && (
                        <div>
                          <small className="text-muted">房间已满</small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
        {selectedRoomId && (
          <div className="mt-2">
            <small className="text-info">
              已选择: {props.rooms.find(r => r.roomId === selectedRoomId)?.displayName}
            </small>
          </div>
        )}
      </div>
      <InputGroup>
        <InputGroup.Text>用户名</InputGroup.Text>
        <FormControl
          as="textarea"
          aria-label="With textarea"
          onChange={e => setUserName(e.target.value)}
          value={userName} />
      </InputGroup>

      <Form.Check
        inline
        type="switch"
        label="我是GM"
        checked={isGm}
        onChange={e => setIsGm(e.target.checked)}
      />
      <Button
        variant={isGm? "warning" : "primary"}
        disabled={userName === "" || selectedRoomId === ""}
        onClick={() => props.handleJoinGame(userName, selectedRoomId, isGm)}>
        加入游戏
      </Button>
    </>;
  }
  return <div className={`bg-${bgColor} text-light`} style={{padding: "1em 20vw 1em 20vw"}}> {inner} </div>;
};

export {
  type GameRoom,
  FabulaUltimaJoinGamePanel,
};